export default __webpack_public_path__ + "files/USGS_TN_SW-RT-Q_TDEC-55751d0657ec8ce9580a85a336db5c8a.pbf";